module.exports = __webpack_public_path__ + "assets/img/3.64e29495.jpg";